import API from './api';

/**************************************************
 IMPORTANT : ne pas utiliser directement les API
 vous devez utiliser les services à la place
 **************************************************/

const exportedObject = {
  get (id_profile, id) {
    return API.get('/profiles/'+id_profile+'/contacts/' + id)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  count (id_profile, params) {
    return API.get('/profiles/'+id_profile+'/contacts/count', {params})
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  getAll (id_profile, params) {
    return API.get('/profiles/'+id_profile+'/contacts', {params})
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  create (id_profile, data) {
    return API.post('/profiles/'+id_profile+'/contacts', data)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  update (id_profile, id, data) {
    return API.post('/profiles/'+id_profile+'/contacts/' + id, data)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  delete (id_profile, id) {
    return API.delete('/profiles/'+id_profile+'/contacts/' + id)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
}

export default exportedObject;
